import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { ClientAdjustmentReport } from "../../../components/Reports/ClientAdjustmentReport";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";

export interface IClientAdjustmentReportPage {}

export const ClientAdjustmentReportPage: FC<IClientAdjustmentReportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Client Adjustment Report"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<ClientAdjustmentReport />}
    />
  );
};
